import appearance from "../../assets/appearance.svg";
import { api } from "../../state/api";
import { FeatureFlag, type AppResponse } from "../../state/api.types";
import { useAuthHasFeatureFlag } from "../../state/hooks";
import { useDocumentTitle } from "../../utilities/useDocumentTitle";
// import { AppearanceBrandModeCard } from "./AppearanceBrandModeCard";
import { AppearanceFaviconCard } from "./AppearanceFaviconCard";
import { AppearanceLogoCard } from "./AppearanceLogoCard";
import { AppearanceNameCard } from "./AppearanceNameCard";
import { AppearanceSupportCard } from "./AppearanceSupportCard";

type AppearancePageProps = {
  app: AppResponse;
};

export const AppearancePage = (props: AppearancePageProps) => {
  const getConfiguration = api.useGetConfigurationQuery(props.app.uuid);
  const showRenewalContact = useAuthHasFeatureFlag(FeatureFlag.RenewalContact);

  useDocumentTitle("Appearance");

  return (
    <div className="p-4xl">
      <div className="mb-7xl flex items-center gap-xl">
        <img
          className="h-12 w-12 object-contain"
          alt="appearance"
          src={appearance}
        />
        <div className="text-display-sm font-semibold">Appearance</div>
      </div>
      {getConfiguration.data && (
        <div className="mx-auto w-full max-w-xl space-y-4xl">
          {/*<AppearanceBrandModeCard*/}
          {/*  app={props.app}*/}
          {/*  configuration={getConfiguration.data}*/}
          {/*/>*/}
          <AppearanceNameCard
            app={props.app}
            configuration={getConfiguration.data}
          />
          <AppearanceLogoCard
            key={`logo-${String(getConfiguration.data.logo)}`}
            app={props.app}
            configuration={getConfiguration.data}
          />
          <AppearanceFaviconCard
            key={`favicon-${String(getConfiguration.data.favicon_logo)}`}
            app={props.app}
            configuration={getConfiguration.data}
          />
          {showRenewalContact && (
            <AppearanceSupportCard
              app={props.app}
              configuration={getConfiguration.data}
            />
          )}
        </div>
      )}
    </div>
  );
};
